// extracted by mini-css-extract-plugin
module.exports = {"container":"_21Wpr0A","letterGroup":"_2pqauan","letterChild":"_1DkKSeD"};